import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {populateStore} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'BLOG_UPDATE',
    smsDelete : 'BLOG_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        blog: [],
        blog_detail: {},
        submitSuccess: false,
        blogLoading: false,
        blogError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_BLOG(state, blog) {
            state.blog = blog;
        },

        SET_BLOG_DETAIL(state, blog) {
            state.blog_detail = blog;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        BLOG_LOADING (state, loading) {
            state.blogLoading = loading;
        },

        BLOG_ERROR (state, hasError) {
            state.blogError = hasError;
        }
    },

    actions: {
        async addBlog ({commit, dispatch}, payload) {
            commit('BLOG_LOADING', true);
            commit('BLOG_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_blog, payload.blog, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchBlog')
                return response

            } catch (e) {
                commit('BLOG_ERROR', true);
                return e.response ? e.response.data : { code: 500, response: 'Something went wrong' }
            } finally {
                commit('BLOG_LOADING', false);
            }
        },

        async fetchBlog ({ commit }) {
            commit('BLOG_LOADING', true);
            commit('BLOG_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.blog_list, config);
                let response = result.data
                commit('SET_BLOG', response.results || response.data || []);

            } catch(error) {
                commit('BLOG_ERROR', true);
            } finally {
                commit('BLOG_LOADING', false);
            }
        },

        async fetchBlogDetail ({ commit }, payload) {
            commit('BLOG_LOADING', true);
            commit('BLOG_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.blog_detail + payload, config);
                let response = result.data.data
                commit('SET_BLOG_DETAIL', response);

            } catch(error) {
                commit('BLOG_ERROR', true);
            } finally {
                commit('BLOG_LOADING', false);
            }
        },

        async updateBlog ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_blog + payload.slug, payload.blog, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchBlog')
                return response

            } catch (e) {
                commit('BLOG_ERROR', true);
                return e.response ? e.response.data : { code: 500, response: 'Something went wrong' }
            }
        },

        async togglePublished ({dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.blog_published_toggle + payload, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchBlog')
            return response
        },

        async toggleFeatured ({dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.blog_featured_toggle + payload, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchBlog')
            return response
        },

        async deleteBlog({dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.blog_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchBlog')
            return response
        }
    },

    getters: {}
}
